import { createSlice } from "@reduxjs/toolkit";

const initialUserGroupAuthorizationState = {
  actionLoading: false,
  userGroups: [],
  moduleAndAuthorities: []
};

export const userGroupAuthorizationSlice = createSlice({
  name: "userGroupAuthorization",
  initialState: initialUserGroupAuthorizationState,
  reducers: {
    startCall: (state) => {
      state.actionLoading = true;
    },
    // getList
    listFetched: (state, action) => {
      state.actionLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userGroups = action.payload.entity && action.payload.entity.userGroups;
      state.modules = action.payload.entity && action.payload.entity.modules;
    },
    //getAuthorities
    authoritiesFetched: (state, action) => {
      state.actionLoading = false;
      state.moduleAndAuthorities = action.payload;
    },
    //saveAuthorities
    authoritiesSaved: (state) => {
      state.actionLoading = false;
    },
    // cleanAuthorities
    authoritiesCleaned: (state) => {
      state.moduleAndAuthorities = [];
    }
  }
});